// Spalvų paletė maršrutams
export const ROUTE_COLORS = [
    '#2196F3',
    '#FF9800',
    '#4CAF50',
    '#9C27B0',
    '#F44336',
    '#00BCD4',
    '#FFEB3B',
    '#795548',
    '#E91E63',
    '#3F51B5' // Indigo
];
// Fallback stočių sąrašai (1520 mm vėžė)
export const STATIONS_1520 = [
    "Akmenė", "Alytus", "Baisogala", "Bezdonys", "Bugeniai", "Darbėnai", "Dotnuva",
    "Dūkštas", "Dūseikiai", "Gaižiūnai", "Gimbogala", "Giruliai",
    "Gubernija", "Gudžiūnai", "Gustonys", "Ignalina", "Jašiūnai", "Jiesia", "Jonaitiškiai",
    "Jonava", "Joniškis", "Kaišiadorys", "Kalnėnai", "Kalvarija", "Kaunas",
    "Kazlų Rūda", "Kėdainiai", "Kena", "Kybartai", "Kirtimai", "Kyviškės", "Kyviškės II,V keliai",
    "Klaipėda", "Kretinga", "Kretingalė", "Kūlupėnai", "Kupiškis", "Kuršėnai", "Kužiai", "Lentvaris",
    "Lieplaukė", "Linkaičiai", "Lukšiai", "Marcinkonys", "Marijampolė", "Matuizos", "Mauručiai",
    "Mažeikiai", "Meškuičiai", "Mockava", "Naujoji Vilnia", "Pabradė", "Pagėgiai",
    "Pakruojis", "Palemonas", "Paneriai", "Panevėžys", "Papilė", "Pavenčiai",
    "Pilviškiai", "Plungė", "Pravieniškės", "Radviliškis", "Raudėnai", "Rimkai",
    "Rokai", "Rokiškis", "Rūdiškės", "Senieji Trakai", "Skuodas", "Stasylos",
    "Stoniškiai", "Šateikiai", "Šeduva", "Šeštokai", "Šiauliai", "Šilainiai",
    "Šilėnai", "Šilutė", "Švenčionėliai", "Tarvainiai", "Tauragė", "Telšiai", "Tytuvėnai",
    "Trakai", "Tryškiai", "Turmantas", "Utena", "Vaidotai", "Valčiūnai", "Valkininkai", "Varėna",
    "Viduklė", "Viekšniai", "Vievis", "Vilkaviškis", "Vilkyčiai", "Vilnius", "Vinčai",
    "VS Bugeniai", "VS Joniškis", "VS Kena", "VS Kybartai", "VS Marcinkonys",
    "VS Mažeikiai", "VS Mockava", "VS Pagėgiai", "VS Rokiškis", "VS Skuodas",
    "VS Stasylos", "VS Turmantas", "Zokniai", "Žasliai", "Žeimiai"
];
// Fallback stočių sąrašai (1435 mm vėžė)
export const STATIONS_1435 = [
    "Jiesia", "Kalvarija", "Kaunas", "Kazlų Rūda", "Marijampolė", "Mauručiai",
    "Mockava", "Palemonas", "Rokai", "Šeštokai", "Vinčai", "VS Mockava"
];
export const MAX_ROUTES_COUNT = 5; // Maksimalus maršrutų kiekis (4 alternatyvūs + 1 pagrindinis)
